export const Column = [
  {
    Header: "To/From",
    accessor: "user",

    disableFilters: true,
  },
  {
    Header: "Date",
    accessor: "date",

    disableFilters: true,
  },
  {
    Header: "Type",
    accessor: "type",
  },
  {
    Header: "Currency",
    accessor: "currency",
  },
  {
    Header: "Rating",
    accessor: "ratings",
  },

  {
    Header: "FeedBack",
    accessor: "feedback",
  },
];
